// Polyfill: https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

// Polyfill: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

window.slate = window.slate || {};
window.theme = window.theme || {};
window.Events = new EventEmitter();

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;
        var options = variant.options;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      var map = {
        "productform:variantchange": variant,
        "productform:variantchangeunavailable": !variant,
        "productform:variantchangeavailable": variant && variant.available,
        "productform:variantchangesoldout": variant && !variant.available
      };

      Object.keys(map).forEach(function(key) {
        if( map[key] ) {
          Events.trigger(key, [variant]);
        }
      });

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      console.log('error');
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initVariants();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      console.log('initVariants');
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }


      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $('.form-submit, div[data-price-wrapper]').removeClass('sold-out');
        $('.sold-out-text').addClass('sold-out');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $('.sold-out-text').removeClass('sold-out');
        $('.form-submit, div[data-price-wrapper]').addClass('sold-out');
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
      console.log(variant.price);

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
  
        
  /* NEW BACK IN STOCK LINK SWITCHER - JG */
  // only run on collection pages:
  if ($("body").hasClass("template-collection")) {
       stockLink();
  }
  // change link URL based on current URL
  function stockLink(){
      var sourceURL = window.location.href; 
      var pageString = window.location.search;
      if ( sourceURL.indexOf("-in-stock") >= 0 ) {
        // URL has "-in-stock" in it
          $('#stock_toggle').addClass('active');
          // create checkbox link url (remove -in-stock)
        if (window.location.href.indexOf("?") > -1) {
            // "-in-stock" and WITH ?
              var preURL = hash = sourceURL.substr(0, (sourceURL + "?").indexOf("?"));
          	  var newPreURL = preURL.replace("-in-stock", "");
              var linkURL = newPreURL + pageString;
        } else { 
            // "-in-stock" and withOUT ?
            var linkURL = sourceURL.replace("-in-stock", "");
        }        
      } else {
        // URL DOES NOT have "-in-stock" in it
          if (window.location.href.indexOf("?") > -1) {
            // not "-in-stock" and WITH ?
              var preURL = hash = sourceURL.substr(0, (sourceURL + "?").indexOf("?"));
              var linkURL = preURL + "-in-stock" + pageString;
          } else { 
             // not "-in-stock" and withOUT ?
              var linkURL = sourceURL + "-in-stock";    
          }

      }
      $('#stock_toggle a').attr('href', linkURL);

    
  }

  

  

  
  

});






// ======= RESPONSIVE SIZES =======
responsiveSizeDetect();
var responsiveSize;
function responsiveSizeDetect(){  
  var emwidth = $(window).width() / parseFloat($("body").css("font-size"));
  //console.log("emwidth = " + emwidth);
  //console.log("window width = " + $(window).width());
  if (emwidth >= 40 ){
    responsiveSize = 'desktop';
  } else {
    responsiveSize = 'mobile';
  }
  //console.log("responsiveSize = " + responsiveSize);
}
  
// ======= RESPONSIVE SIDEBAR FUNCTIONALITY =======

sidebarOnResize();
function sidebarOnResize(){    
  //console.log('sidebarOnResize called');

  // ### all sizes functionality ###
  if ($("body").hasClass("template-collection")) {
      contextSidebarAccordion();
  } 
  
  if (responsiveSize == 'mobile') {
  // ### mobile sizes functionality ### 
    //console.log("sidebar mobile");
    // collapse accordion
    //$('#shopify-section-sidebar ul').accordion( "option", "active", false );
    
  } else if (responsiveSize == 'desktop') { 
  // ### desktop sizes functionality ###
    //console.log("sidebar desktop");  
    // context aware accordion

  }
}

/* OPEN SIDEBAR ACCORDION TO CORRECT SECTION FOR COLLECTIONS: */
function contextSidebarAccordion () {
  //console.log("contextSidebarAccordion called");
  var sourcePath = window.location.pathname;
  if ( sourcePath.indexOf("-in-stock") >= 0 ) {
      var modPath = sourcePath.replace("-in-stock", "");
  } else { 
      var modPath = sourcePath;
  }
  //console.log("modPath = " + modPath);
   if (responsiveSize == 'mobile') {
    // ### mobile sizes functionality ### 
      //console.log("contextSidebarAccordion MOBILE");
      $('#shopify-section-sidebar .sidebar-menu-mobile .new-menu-child-li > a').each(function(){
          if ($(this).attr("href") == modPath){
             // highlight link with selected style
              var $current = $(this);  
              $current.addClass("selected");
          }
       });
    } else if (responsiveSize == 'desktop') { 
    // ### desktop sizes functionality ###
      //console.log("contextSidebarAccordion DESKTOP");
      // context aware accordion
       $('#shopify-section-sidebar .sidebar-menu-tablet .new-menu-child-li > a').each(function(){
          if ($(this).attr("href") == modPath){
              var $current = $(this);
              var $targetLI = $(this).closest('li.new-menu-parent-li');
              var $targetA = $(this).closest('li.new-menu-parent-li').children('a');
              // highlight link with selected style
              $current.addClass("selected");
              $targetLI.addClass("active-page-parent-li");
              $targetA.addClass("active-page-parent-anchor");
              // expand parent menu
              setTimeout(function () {
                var parentExpanded = $targetLI.attr('aria-expanded');
                //console.log("parentExpanded = " + parentExpanded);
                if ( parentExpanded == 'false' ){
                  $targetA.trigger('click');
                }    
              }, 0);
          }
       });
  
    }

}



$(window).resize(function(){
  responsiveSizeDetect();
  sidebarOnResize();
});



function addSearchAsterisk() {
  	var qvalue = $(".ui-overlay-search form input[type='search']").val();
    var qvalueStr = qvalue.split(" ");
    var newqvalue = "";
    for(var i =0; i < qvalueStr.length; i++){
    	newqvalue += qvalueStr[i] + "* ";   
    }
  
  // assign new value: .val("fgg");
  $(".ui-overlay-search form input[type='search']").val(newqvalue);
     // document.getElementById('q').value = newqvalue;  
}

function removeTextAsterisk(element) { 
	var stringSource = $(element).text();
    console.log("source term = " + stringSource);
    var modString = stringSource.split("*").join("");
    var finalString =modString.replace(/\s+/g,' ').trim();
    console.log("mod term = " + finalString);
    $(element).text(finalString);
}

function removeValAsterisk(element) { 
	var stringSource = $(element).val();
    console.log("source term = " + stringSource);
    var modString = stringSource.split("*").join("");
    var finalString =modString.replace(/\s+/g,' ').trim();
    console.log("mod term = " + finalString);
    $(element).val(finalString);
}

$('input[name="post_type"]').change(function(){
  if($(this).val() == 'product'){
    $(this).closest('form').removeClass('site').addClass('shop');
    $(this).closest('form').attr('action', '/search');
    $(this).closest('form').find('input[type="search"]').attr('name', 'q');
  } else {
    $(this).closest('form').removeClass('shop').addClass('site');
    $(this).closest('form').attr('action', 'https://www.floretflowers.com');
    $(this).closest('form').find('input[type="search"]').attr('name', 's');
  }
});

$(".ui-overlay-search").on("submit", "form", function(){
  if ($(".ui-overlay-search form").hasClass('shop')) {
    	addSearchAsterisk();
    	var finalqvalue = $(".ui-overlay-search form input[type='search']").val();
    	$(".ui-overlay-search form input[type='search']").css('opacity', '0');
      	//alert("shop search terms = " + finalqvalue);
    } else {
      //alert("site search");
    }
    
}); // end doc ready


// Accordion

$( function() {
  $( ".filter-accordion" ).accordion({
    heightStyle: "content",
    collapsible: true,
    active: false
  });
});



// Update variant image
$('a[data-product-single-thumbnail]').click(function(e){
  e.preventDefault();
  var new_image = $(this).attr('href');
  $('img[data-product-featured-image]').prop('src', new_image);
});

// Prevent exceeding max in cart
$('.cart-table input[type="number"]').on('change input keypress', function(){
  if(parseInt($(this).val()) > $(this).prop('max')){
    $(this).val($(this).prop('max'));
  }
});

// Update variant image
$('a.product-single__thumbnail').click(function(e){
  e.preventDefault();
  var new_image = $(this).attr('href');
  $('#ProductPhotoImg').prop('src', new_image);
});

$(document).ready(function() {
  // Mobile image slider
  $('.product-image-slider').slick({
    fade: true,
    arrows: false,
    dots: true,
    infinite: true
  });

  $('.product-image-slider').slick('setPosition');

  // PDP Mobile article sliders
  if($('.js_pdp-mobile-htg-slider').length){
    $('.js_pdp-mobile-htg-slider').slick({
      arrows: false,
      dots: true,
      infinite:false,
      slidesToShow: 2
    });
  }

  if($('.js_pdp-mobile-sources-slider').length){
    $('.js_pdp-mobile-sources-slider').slick({
      arrows: false,
      dots: true,
      infinite:false,
      slidesToShow: 2
    });
  }
  
  $(window).resize(function(){
    $('.product-image-slider').slick('setPosition');
  });




  
});

$(window).on('load', function () {
    $('.product-image-slider').slick('refresh');
});




// PDP desktop thumb slider:
$('.image-thumbnails').on("init", function() {
  setTimeout(function () {
    $('.image-thumbnails').slick('refresh');
  }, 0);
});


// Thumbnail slider
$('.image-thumbnails').slick({
  arrows: true,
  dots: true,
  // centerMode: true,
  slidesToShow: 4,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1425,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 661,
      settings: {
        vertical: false,
        slidesToShow: 3
      }
    }
  ]
});

// Auto change image on thumbnail next/prev
$('.image-thumbnails').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  $('#ProductPhotoImg').attr('src', $('.slick-slide[data-slick-index="' + nextSlide + '"] a').attr('href'));
});

// Collection grid

(function module_collection_grid() {
  function Self(element, events, options, module) {
    Events.on("collectionnextlink:load", function(new_document) {
      var new_element = new_document.querySelector("[data-module-collection-grid]");

      if( new_element ) {
        element.innerHTML += new_element.innerHTML
      }
    });
  };

  function CollectionGrid(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element]
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });
  };

  var elements = document.querySelectorAll("[data-module-collection-grid]");

  elements.forEach(function(element) {
    var options = element.getAttribute("data-module-collection-grid");
        options = JSON.parse(options || "{}");

    CollectionGrid(element, options);
  });
})();

// Collection next link
(function module_collection_next_link() {
  function Self(element, events, options, module) {
    
 var myhash = window.location.hash;
    if (location.hash) {
      if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
  setTimeout(function() {
    window.scrollTo(0, 0);
  }, 1);
        }
}
 var nyhash = parseInt(myhash.replace('#pc-',''));
 var i = 1;
 function ajaxCall(){
       $.get(element.href, function(res) {
            element.classList.remove("is-loading");
            var new_document = document.createElement("html");
            new_document.innerHTML = res;
          var new_element = new_document.querySelector("[data-module-collection-next-link]");
            if( new_element ) {
              element.href = new_element.href;
            } else {
              element.style.display = "none";
            }
          console.log(element.href);
            Events.trigger("collectionnextlink:load", [new_document, false]);
         if(i++ < nyhash){ ajaxCall(); }else{
           var myProd = nyhash * 24;  
           console.log(myProd);
           $([document.documentElement, document.body]).animate({
             scrollTop: $(".product-grid .grid__item:nth-child("+myProd+")").offset().top
    }, 1000);
           setTimeout(function(){ $("#cc-loading").fadeOut(); }, 2000);           
         }
        });
  }

 if(myhash.indexOf("#pc-") >= 0){
     element.classList.add("is-loading");
   		$("#cc-loading").show();
     ajaxCall();      		
 }
    element.addEventListener("click", function(event) {
      event.preventDefault();
      

      element.classList.add("is-loading");

      $.get(element.href, function(res) {
        element.classList.remove("is-loading");

        var new_document = document.createElement("html");
            new_document.innerHTML = res;

        Events.trigger("collectionnextlink:load", [new_document]);
        
      });
    });

    Events.on("collectionnextlink:load", function(new_document, cTrack = true) {
      //console.log("EVENT FIRE");
      var new_element = new_document.querySelector("[data-module-collection-next-link]");

      if( new_element ) {
        element.href = new_element.href;
      } else {
        element.style.display = "none";
      }
      toggleOutOfStock();
      //ReloadSmartWishlist();
      var mhash = window.location.hash;
      if(cTrack){
      if (mhash.indexOf("#pc-") >= 0){
        var nhash = parseInt(mhash.replace('#pc-','')) + 1;
	  window.location.hash = '#pc-' + nhash;
      }
      else{
      window.location.hash = '#pc-1';
      }
      }
    });
  };
  
  function CollectionNextLink(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element]
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });
  };

  var elements = document.querySelectorAll("[data-module-collection-next-link]");

  elements.forEach(function(element) {
    var options = element.getAttribute("data-module-collection-next-link");
        options = JSON.parse(options || "{}");

    CollectionNextLink(element, options);
  });
})();


$("#stockbox").change(function() {
  toggleOutOfStock();
  });
function toggleOutOfStock () {
    if($("#stockbox").is(':checked')) {
        $('.product_soldout').parent().hide();
      
    }else{
   
    $('.product_soldout').parent().show();
    
    }
}



(function module_set_geolocation_cookie() {
  var cookie = Cookies.getJSON("geoloation");

  if( cookie ) {
    return setTimeout(function() {
      Events.trigger("geolocation:success", [cookie]);
    });
  }

  var url = "https://api.ipstack.com/check?access_key=bbe44a059e007c6ecc41879ae0a714d6";

  $.get(url, function(res) {
    // Spoof location to be US - comment out when live
    // res.country_name = "United States";
    // res.country_code = "US";

    Cookies.set("geoloation", res);
    Events.trigger("geolocation:success", [res]);
  });
})();

/*
(function module_product_restricted() {
  function Self(element, events, options, module) {
    Events.on("geolocation:success", function(geolocation) {
      if (options.restricted) {
        if (geolocation.country_code !== "US") {
          events.trigger("self:restricted", [geolocation]);
        }
      }
    });
  };

  function Restricted(element, events, options, module) {
    events.on("self:restricted", function(geolocation) {
      element.style.display = "none";
    });
  };

  function Message(element, events, options, module) {
    events.on("self:restricted", function(geolocation) {
      element.style.display = "block";

      element.innerHTML = element.innerHTML
        .replace(/{{ country }}/g, geolocation.country_name);
    });
  };

  function ProductRestricted(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element],
      restricted: element.querySelectorAll("[data-ref-restricted]"),
      message: element.querySelectorAll("[data-ref-message]")
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });

    refs.restricted.forEach(function(element) {
      var options = element.getAttribute("data-ref-restricted");
          options = JSON.parse(options || "{}");

      Restricted(element, events, options, module);
    });

    refs.message.forEach(function(element) {
      var options = element.getAttribute("data-ref-message");
          options = JSON.parse(options || "{}");

      Message(element, events, options, module);
    });
  };

  var elements = document.querySelectorAll("[data-module-product-restricted]");

  elements.forEach(function(element) {
    var options = element.getAttribute("data-module-product-restricted");
        options = JSON.parse(options || "{}");

    ProductRestricted(element, options);
  });
})();
*/

(function module_bis_load() {
  bis_load();

  function bis_load() {
    if ( window.BIS ) {
      Events.trigger("bis-load");
    } else {
      setTimeout(function () {
        bis_load();
      }, 100);
    }
  };
})();

(function module_bis_trigger() {
  function Self(element, events, options, module) {
    Events
      .on("productform:variantchangeunavailable", hide)
      .on("productform:variantchangeavailable", hide)
      .on("productform:variantchangesoldout", show);

    function show() {
      element.style.display = "block";
    };

    function hide() {
      element.style.display = "none";
    };
  };

  function BisTrigger(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element]
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    Events.on("bis-load", function() {
      refs.self.forEach(function(element) {
        var options = module.options;

        Self(element, events, options, module);
      });
    });
  };

  var elements = document.querySelectorAll("[data-module-bis-trigger]");

  elements.forEach(function(element) {
    var options = element.getAttribute("data-module-bis-trigger");
        options = JSON.parse(options || "{}");

    BisTrigger(element, options);
  });
})();

(function module_cart_form() {
  function Self(element, events, options, module) {
    if (!options.terms_enable) {
      return;
    }

    element.addEventListener("submit", function(event) {
      if (!module.options.checkbox_checked) {
        event.preventDefault();
        alert(options.error);
      }
    });
  };

  function Checkbox(element, events, options, module) {
    element.addEventListener("change", function(event) {
      module.options.checkbox_checked = event.target.checked;
    });
  };

  function CartForm(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element],
      checkbox: element.querySelectorAll("[data-ref-checkbox]")
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });

    refs.checkbox.forEach(function(element) {
      var options = element.getAttribute("data-ref-checkbox");
          options = JSON.parse(options || "{}");

      Checkbox(element, events, options, module);
    });
  };

//   var elements = document.querySelectorAll("[data-module-cart-form]");

//   elements.forEach(function(element) {
//     var options = element.getAttribute("data-module-cart-form");
//         options = JSON.parse(options || "{}");

//     CartForm(element, options);
//   });
  
  $('#cart-checkout-btn').click(function(e){
  	e.preventDefault();
  	var elements = document.querySelectorAll("[data-module-cart-form]");
    if($('.cart-terms input[type="checkbox"]').prop( "checked")) {
      //console.log('checked');
      window.location.href = '/checkout';
      // JG $('#checkout-btn-error').hide();
    } else {
        var error_val = $('form').attr('data-module-cart-form');
      	var final_val = jQuery.parseJSON( error_val );
      	//console.log(final_val.error);
        alert(final_val.error);
        // JG $('#checkout-btn-error').show();
      
    }
  });
})();

// Product page tabs
$(document).ready(function() {
  $('.tabs li').each(function(index) {
    $(this).on('click', function(){
      //console.log('click');
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
      var thisID = $(this).attr('id').replace('-trigger', '');
      var tabBody = $(this).parent().parent().find('#' + thisID);
      $(tabBody).show();
      $(tabBody).siblings('.tab_content').hide();
    });
  });

  // Product page mobile accordion
  $('.jsAccordionTrigger').each(function(index) {
    $(this).on('click', function(){
      console.log('pdp accordion clicked');
      $(this).toggleClass('active');
      $(this).next('.jsAccordionPanel').slideToggle();
      if ($(this).hasClass('js_how-to-grow-accordion-trigger')) {
        $('.js_pdp-mobile-htg-slider').slick('refresh');
              console.log('HTG CLICKED');
      }
      if ($(this).hasClass('js_sources-accordion-trigger')) {
        $('.js_pdp-mobile-sources-slider').slick('refresh');
                      console.log('SOURCES CLICKED');

      }
    });
  });

  
});




// =====================================================
// START JS TAKEN FROM FLORET MAIN SITE


    header = {
        init: function() {
            $(".topbar").length > 0 && $(".header").length > 0 && ($topbar = $(".topbar"),
            $header = $(".header"),
            header.setBodyPadding(),
            header.checkState())
        },
        checkState: function() {
            $(window).width() >= 1024 ? ($topbar.addClass(pinnedClass),
            $header.addClass(pinnedClass),
//            "down" == windowScrollDirectionTolerance && windowScrollTop > 0 ? windowScrollTop > headerDepth && ($header.addClass(collapsedClass),
            // modified to trigger when scrolling 1/4 the height of the header - JG
            "down" == windowScrollDirectionTolerance && windowScrollTop > 0 ? windowScrollTop > (headerDepth / 4) && ( $header.addClass(collapsedClass),$body.addClass(collapsedClass),
            $topbar.hasClass("collapse") && ($topbar.addClass(collapsedClass),
            setTimeout(function() {
              header.setBodyPadding()
            // modified to trigger when scrolling 1/4 the height of the header - JG
//            }, animDurationQuick))) : windowScrollTop < headerDepth && ($header.removeClass(collapsedClass),
            }, animDurationQuick))) : windowScrollTop < ( headerDepth / 4 ) && ($header.removeClass(collapsedClass),$body.removeClass(collapsedClass),
                                                                        
            $topbar.removeClass(collapsedClass),
            setTimeout(function() {
              // not setting another body padding here, it's not necessary and causes a bounce. - JG
              //header.setBodyPadding()

            }, animDurationQuick))) : $body.removeAttr("style");
        },
        setBodyPadding: function() {
          1 == setBodyPadding && (headerDepth = $topbar.outerHeight() + $header.outerHeight(),
          $body.css({
                "padding-top": headerDepth + "px"
            }));
        },
        calcHeight: function() {
            if ("undefined" == typeof $header)
                return 0;
            var t = $header.css("transform")
              , e = t.match(/-?[\d\.]+/g);
            if (null != e)
                var i = parseInt(e[5]);
            else
                var i = 0;
            if ($(window).width() >= 640)
                var n = $topbar.is(":visible") ? $topbar.outerHeight() : 0
                  , o = n + $header.outerHeight() - 1 + i;
            else
                var o = $header.outerHeight();
            return o
        }
    };

    var viewportWidth, viewportHeight, siteHeaderHeight;
    elementDimensions = {
        get: function() {
            viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
            viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
            siteHeaderHeight = $(".header").outerHeight()
        }
    };

    var $topbar, $header, headerDepth, setBodyPadding = !0;
    var startTime, $body = $("body"), readyClass = "ready", activeClass = "active", revealClass = "reveal", staticClass = "static", pinnedClass = "fixed", collapsedClass = "collapsed", fullscreenClass = "fullscreen", offscreenClass = "offscreen", loadingClass = "loading", animDurationVQuick = 100, animDurationQuick = 300, animDurationBase = 500, animDurectionSlow = 700;
    var viewportLaptopHeight = 780
      , breakpointMedium = 640
      , breakpointLarge = 1024
      , breakpointXlarge = 1200
      , breakpointXXlarge = 1440
      , arrowPrevSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.1 20.74"><title>Previous</title><polygon class="cls-1" points="117.1 9.73 3.2 9.74 17.17 1.1 17.17 0 0 10.38 17.16 20.74 17.16 19.64 3.19 11 117.09 11.01 117.1 9.73"/></svg>'
      , arrowNextSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.1 20.74"><title>Next</title><polygon class="cls-1" points="0 9.73 113.9 9.74 99.93 1.1 99.93 0 117.1 10.38 99.94 20.74 99.94 19.64 113.91 11 0.01 11.01 0 9.73"/></svg>'
      , chevronPrevSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.08 14.4"><title>Previous</title><path class="cls-1" d="M0,7.2,7.58,0l.5.64L1.28,7.2l6.8,6.56-.5.64Z"/></svg>'
      , chevronNextSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.08 14.4"><title>Next</title><path class="cls-1" d="M8.08,7.2.5,14.4,0,13.76,6.8,7.2,0,.64.5,0Z"/></svg>';
    debounce = function(t, e, i) {
        var n;
        return function() {
            var o = this
              , s = arguments
              , r = function() {
                n = null,
                i || t.apply(o, s)
            }
              , a = i && !n;
            clearTimeout(n),
            n = setTimeout(r, e),
            a && t.apply(o, s)
        }
    };
    var windowScrollTop = $(window).scrollTop(), windowScrollDirection, windowScrollDirectionTolerance = "down", scrollToleranceDown = 10, scrollToleranceUp = 100, windowLastScrollTop = 0, windowLastScrollChangeUp = 0, windowLastScrollChangeDown = 0;
    winScroll = {
        top: function() {
            windowScrollTop = $(window).scrollTop()
        },
        direction: function() {
            windowScrollTop > windowLastScrollTop ? (windowScrollDirection = "down",
            0 == windowLastScrollChangeDown && (windowLastScrollChangeDown = windowScrollTop,
            windowLastScrollChangeUp = 0),
            windowScrollTop > windowLastScrollChangeDown + scrollToleranceDown && (windowScrollDirectionTolerance = "down")) : (windowScrollDirection = "up",
            0 == windowLastScrollChangeUp && (windowLastScrollChangeUp = windowScrollTop,
            windowLastScrollChangeDown = 0),
            windowScrollTop < windowLastScrollChangeUp - scrollToleranceUp && (windowScrollDirectionTolerance = "up")),
            windowLastScrollTop = windowScrollTop
        },
        toElement: function(t, e) {
            var e = "undefined" != typeof e ? e : animDurationBase;
            void 0 !== t && $("html, body").animate({
                scrollTop: t.offset().top
            }, e)
        }
    };
    viewportOffset = {
        get: function(t) {
            var e = t.offset().top - windowScrollTop;
            return e
        }
    };
    animations = {
        init: function() {}
    };
    noscroll = {
        on: function() {
            $("html, body").addClass("noscroll")
        },
        off: function() {
            $("html, body").removeClass("noscroll")
        }
    };

    var $searchTrigger, $searchOverlay, $searchInput, searchCloseStateClass = "close", $searchTriggerClone;
    search = {
        init: function() {
            $(".ui-overlay-search").length > 0 && $(".search-trigger").length > 0 && ($searchTrigger = $(".search-trigger"),
            $searchOverlay = $(".ui-overlay-search"),
            $searchInput = $("input[type=search]", $searchOverlay),
            $searchTrigger.on("click", function(t) {
                t.preventDefault(),
                search.open()

            }))
        },
        calcPos: function() {
            if ($(window).width() >= 640)
                var t = header.calcHeight()
                  , e = viewportHeight - t + "px";
            else
                var t = 0
                  , e = "100%";
            $searchOverlay.css({
                top: +(t + 1) + "px",
                height: e
            })
        },
        open: function() {
            removeValAsterisk('form.shop input#Search'),
            search.calcPos(),
            $searchOverlay.addClass(activeClass),
            $searchTrigger.addClass(searchCloseStateClass),
            noscroll.on(),
            $(window).width() >= 640 || ($searchTriggerClone = $(".search-trigger").clone(),
            $searchTriggerClone.addClass("search-trigger--clone"),
            $searchOverlay.append($searchTriggerClone)),
            setTimeout(function() {
                $searchOverlay.addClass(revealClass),
                $searchInput.focus()
            }, 100),
            $searchTrigger.off().on("click", function(t) {
                t.preventDefault(),
                search.close()
            })
            $searchTriggerClone.off().on("click", function(t) {
                t.preventDefault(),
                search.close()
            })
        },
        close: function() {
            $searchOverlay.removeClass(revealClass),
            $searchTrigger.removeClass(searchCloseStateClass),
            search.reset(),
            noscroll.off(),
            setTimeout(function() {
                $searchOverlay.removeClass(activeClass)
            }, animDurationBase)
        },
        reset: function() {
            $searchTrigger.off().on("click", function(t) {
                t.preventDefault(),
                search.open()
            })
        }
    };




        hero = {
          init: function() {
            $(".category-wrapper").length > 0 && hero.single()
          },
          single: function() {
            $heroSingle = $(".category-wrapper");
            var t = ($(".hero", $heroSingle),
            $(".coll-hero-content", $heroSingle)),
            e = $(".hero-image", $heroSingle);
            t.addClass(activeClass);
            e.addClass(activeClass);
          }
      };


	// ---------------------
	//  PRIMARY NAV
	// ---------------------
	var $primaryNavContainer;
	var $primaryNav;
	var $navTier1;
	var $navTier2;
	var tier2ActiveClass = 'tier2';
	var tier3ActiveClass = 'tier3';
	var $navTier1SubMenus;
	var $navTier2SubMenus;
	var $tierBackButton;
	var $primaryNavClose;
	var $primaryNavTrigger;

	primaryNav = {
		init: function() {
			if( $('.l-header__nav .l-header__nav__menu').length > 0 ) {
				$primaryNavContainer = $('.l-header__nav .l-header__nav__menu');
				$primaryNavWrapper = $('.l-header__nav .l-header__nav__menu > .l-header__nav__menu__wrapper');
				$primaryNav = $('.l-header__nav .l-header__nav__menu > .l-header__nav__menu__wrapper > ul');
				$navTier1 = $('.l-header__nav .l-header__nav__menu > .l-header__nav__menu__wrapper > ul > li');
				$navTier2 = $('.l-header__nav .l-header__nav__menu > .l-header__nav__menu__wrapper > ul > li > .sub-menu-wrap > .row > ul > li');
				$navTier1SubMenus = $navTier1.children('.sub-menu-wrap');
				$navTier2SubMenus = $navTier2.children('.sub-menu-wrap');
				$tierBackButton = $('.l-header__nav__menu__meta__back', $primaryNavContainer);
				$primaryNavClose = $('.l-header__nav__menu__meta__close', $primaryNavContainer);
				$primaryNavTrigger = $('.l-header__nav__menu-trigger');

				// Check state
				primaryNav.checkState();
			}
		},
		checkState: function() {
			if( Foundation.MediaQuery.atLeast('large') ) {
				// Full menu
				primaryNav.fullMenu();
			} else {
				// Mobile menu
				primaryNav.mobileMenu();
			}
		},
		resetMenu: function() {
			// Clear nav links events
			$('a, li', $primaryNav).off();
			// Client mobile nav active tiers
			$primaryNav.removeClass(tier2ActiveClass);
			$primaryNav.removeClass(tier3ActiveClass);
			// Clear active submenus
			$navTier1SubMenus.removeClass(activeClass);
			$navTier2SubMenus.removeClass(activeClass);
			// Clear tier back button events
			$tierBackButton.off();
			// Remove cloned items
			$('.cloned-item', $primaryNavContainer).remove();
		},
		fullMenu: function() {
			// Full menu events
			// Reset menu
			primaryNav.resetMenu();

			// Tier 1 links
			$navTier1.each(function() {
				var $this = $(this);
				// Check for submenu
				if( $this.children('.sub-menu-wrap').length > 0 ) {
					var $thisSubMenu = $this.children('.sub-menu-wrap');
					// Setup submenu hover
					$this.on('mouseenter', function() {
						$this.addClass(activeClass);
						$thisSubMenu.addClass(activeClass);
					}).on('mouseleave', function() {
						$this.removeClass(activeClass);
						$thisSubMenu.removeClass(activeClass);
					});
				}
			});
		},
		mobileMenu: function() {
			// Mobile menu events
			// Reset menu
			primaryNav.resetMenu();

			// Tier 1 links
			$navTier1.each(function() {
				var $this = $(this).find('> a');
				// Check for submenu
				if( $this.siblings('.sub-menu-wrap').length > 0 ) {
					var $thisSubMenu = $this.siblings('.sub-menu-wrap');
					// Setup tier1 click
					$this.on('click', function(e) {
						e.preventDefault();
						$primaryNav.addClass(tier2ActiveClass);
						$primaryNavWrapper.addClass(tier2ActiveClass);
						$thisSubMenu.addClass(activeClass);
						// Insert this item into submenu
						var $thisMenu = $thisSubMenu.find('> .row > ul');
						$thisMenu.prepend('<li class="cloned-item"></li>');
						$this.clone().prependTo( $('li', $thisMenu).first() );
						$thisSubMenu.find('> .row > ul .cloned-item a').append(' Overview');
					});
				}
			});

			// Tier 2 links
			$navTier2.each(function() {
				var $this = $(this).find('> a');
				// Check for submenu
				if( $this.siblings('.sub-menu-wrap').length > 0 ) {
					var $thisSubMenu = $this.siblings('.sub-menu-wrap');
					// Setup tier2 click
					$this.on('click', function(e) {
						e.preventDefault();
						$primaryNav.addClass(tier3ActiveClass);
						$primaryNavWrapper.addClass(tier3ActiveClass);
						$thisSubMenu.addClass(activeClass);
						// Insert this item into submenu
						var $thisMenu = $thisSubMenu.find('> .row > ul');
						$thisMenu.prepend('<li class="cloned-item"></li>');
						$this.clone().prependTo( $('li', $thisMenu).first() );
						$thisSubMenu.find('> .row > ul .cloned-item a').prepend('All ');
					});
				}
			});

			// Back button
			$tierBackButton.on('click', function(e) {
				e.preventDefault();
				if( $primaryNav.hasClass(tier3ActiveClass) ) {
					// Back to tier2
					$primaryNav.removeClass(tier3ActiveClass);
					$primaryNavWrapper.removeClass(tier3ActiveClass);
					setTimeout(function() {
						// Clear active submenus
						$navTier2SubMenus.removeClass(activeClass);
						// Remove cloned items
						$('.sub-menu-wrap .cloned-item', $navTier2).remove();
					}, animDurationBase);
				} else {
					// Back to tier1
					$primaryNav.removeClass(tier2ActiveClass);
					$primaryNavWrapper.removeClass(tier2ActiveClass);
					setTimeout(function() {
						// Clear active submenus
						$navTier1SubMenus.removeClass(activeClass);
						// Remove cloned items
						$('.sub-menu-wrap .cloned-item', $navTier1).remove();
					}, animDurationBase);
				}
			});

			// Close button
			$primaryNavClose.on('click', function(e) {
				e.preventDefault();
				// Close menu
				$primaryNavContainer.removeClass(revealClass);
				setTimeout(function() {
					$primaryNavContainer.removeClass(activeClass);
					// Reset menu
					primaryNav.resetMenu();
					// Check state
					primaryNav.checkState();
					noscroll.off();
				}, animDurationQuick);
			});

			// Menu trigger
			$primaryNavTrigger.on('click', function(e) {
				e.preventDefault();
              console.log("$primaryNavTrigger")
				// Open menu
				$primaryNavContainer.addClass(activeClass);
				setTimeout(function() {
					// Reveal after brief delay on account of display: block
					$primaryNavContainer.addClass(revealClass);
					noscroll.on();
				}, 100);
			});
		}
	}



$(document).ready(function() {
    $(document).foundation(),
      setTimeout(function(){
        header.init(),
        search.init(),
        hero.init(),
        elementDimensions.get(),
        primaryNav.init(),
        void 0 != $header && windowScrollTop > 0 && (windowScrollDirectionTolerance = "down",
        header.checkState())
    }, 100);
});


$(window).on('load', function (t) {
   startTime = t.timeStamp,
   void 0 != $header && $(window).width() >= 1024 && header.setBodyPadding()
});



$(window).scroll(function(t) {
    if (startTime && !(t.timeStamp - startTime < 50)) {
        var e = debounce(function() {
            winScroll.top(),
            winScroll.direction(),
            void 0 != $header && header.checkState()
        });
        e()
    }
});

$(window).resize(function() {
  primaryNav.init(),
  primaryNav.checkState();
    var t = debounce(function() {
        elementDimensions.get(),
        void 0 != $header && (header.setBodyPadding(),
        header.checkState()),
        void 0 != $searchOverlay && search.calcPos(),
        void 0 != $searchOverlay && "small" == Foundation.MediaQuery.current
    });
    t()
});

// END JS TAKEN FROM FLORET

// User agent detection for print bugs
$(document).ready(function() { 
  var useragent = navigator.userAgent;
  var browser;
  //console.log("User agent is: " + useragent);
  if ( useragent.includes('Chrome') && !useragent.includes('Android') ){
    var browser = 'Chrome Desktop';  
    var layoutClass = 'chrome-desktop';
  } else if ( useragent.includes('Chrome') && useragent.includes('Android') ){
    var browser= 'Chrome Android';
    var layoutClass = 'chrome-android';
  } else if ( useragent.includes('iPhone') ) {
    var browser = 'iPhone Chrome or Android';
    var layoutClass = 'iphone';
  } else if ( useragent.includes('iPad') ) {
    var browser = 'iPad Chrome';
    var layoutClass = 'chrome-ipad';
  } else if ( useragent.includes('Safari') && !useragent.includes('Chrome') && !useragent.includes('iPhone') && !useragent.includes('iPad') ){
    if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
      var browser = 'Safari iPad';  
      var layoutClass = 'safari-ipad';
    } else {
      var browser = 'Safari Desktop';  
      var layoutClass = 'safari-desktop'
    }
  }
  //console.log(browser);
  $('body').attr('data-browser', layoutClass); 
  
});

// orientation detection for iphone print bugs
var orientationClass;
function checkOrientation(){
  var screenWidth = $(window).width();
  var screenHeight = $(window).height();
  if (screenWidth > screenHeight) {
    var orientationClass = 'landscape';
  } else {
    var orientationClass = 'portrait';
  }
  //console.log("orientation = " + orientationClass);
  $('body').attr('data-orientation', orientationClass); 
}

$(window).resize(function(){
  checkOrientation();
});

$(document).ready(function() { 
  checkOrientation();
});


// Show cookie revisit only if in a compliant region, invoke revisit modal manually
$(window).on('load', function () {
  setTimeout(function() { 
     if($(".cc-window").length){
        console.log("compliance region = true");
       $('#revisit-cookies').show();
        $(document).on("click","#revisit-cookies", function(){
          $(".cc-revoke").trigger("click");
        });
      } else {
        console.log("compliance region = false");
      }
  }, 2000);
});

